import { render, staticRenderFns } from "./link-to.vue?vue&type=template&id=7a53a8b8&scoped=true"
import script from "./link-to.vue?vue&type=script&lang=js"
export * from "./link-to.vue?vue&type=script&lang=js"
import style0 from "./link-to.vue?vue&type=style&index=0&id=7a53a8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53a8b8",
  null
  
)

export default component.exports